import { ChangeEvent, FC } from "react"
import { useAppDispatch, useAppSelector } from "@/store"
import {
  DevToolsSelectors,
  setEmulatePhoneDevice
} from "@/store/slices/devTools"
import styles from "./EmulatePhoneDeviceSection.module.scss"

export const EmulatePhoneDeviceSection: FC = () => {
  const dispatch = useAppDispatch()
  const emulatePhoneDevice = useAppSelector(
    DevToolsSelectors.selectEmulatePhoneDevice()
  )

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    dispatch(setEmulatePhoneDevice(e.target.checked))
  }

  return (
    <section className={styles.EmulatePhoneDeviceSection}>
      <h3 className={styles.EmulatePhoneDeviceSection_title}>Phone device</h3>
      <label className={styles.EmulatePhoneDeviceSection_row}>
        <span className={styles.EmulatePhoneDeviceSection_label}>
          Emulate phone device
        </span>
        <input
          type="checkbox"
          className={styles.EmulatePhoneDeviceSection_checkbox}
          checked={emulatePhoneDevice}
          onChange={handleChange}
        />
      </label>
    </section>
  )
}
